import { render } from "./PenjadwalanRombel.vue?vue&type=template&id=4c2af107"
import script from "./PenjadwalanRombel.vue?vue&type=script&lang=js"
export * from "./PenjadwalanRombel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__